module.exports = __webpack_public_path__ + "static/media/placeholder.1c73fb57.png";